import React, {Component} from 'react';
import {Grow, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import withStyles from "@mui/styles/withStyles";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const CONFETTI_COLORS = ['#FFD700', '#FFA000', '#FF6F00', '#66bb6a', '#4CAF50', '#81C784', '#FFECB3'];
const CONFETTI_COUNT = 50;

const useStyles = () => ({
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        pointerEvents: 'none',
        overflow: 'hidden',
    },
    confettiPiece: {
        position: 'absolute',
        opacity: 0,
        animation: '$confettiBurst 3.5s ease-out forwards',
    },
    '@keyframes confettiBurst': {
        '0%': {
            opacity: 1,
            transform: 'translateY(50vh) scale(0)',
        },
        '15%': {
            opacity: 1,
            transform: 'translateY(20vh) scale(1.2)',
        },
        '100%': {
            opacity: 0,
            transform: 'translateY(-20vh) scale(0.4)',
        },
    },
    banner: {
        position: 'fixed',
        top: '35%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10000,
        pointerEvents: 'none',
        textAlign: 'center',
        animation: '$bannerPop 3.5s ease-out forwards',
    },
    '@keyframes bannerPop': {
        '0%': {
            opacity: 0,
            transform: 'translate(-50%, -50%) scale(0.3)',
        },
        '15%': {
            opacity: 1,
            transform: 'translate(-50%, -50%) scale(1.1)',
        },
        '30%': {
            transform: 'translate(-50%, -50%) scale(1)',
        },
        '75%': {
            opacity: 1,
        },
        '100%': {
            opacity: 0,
            transform: 'translate(-50%, -50%) scale(0.9)',
        },
    },
});

class GoalCompletedCelebration extends Component {

    constructor(props) {
        super(props);
        this.confettiPieces = Array.from({length: CONFETTI_COUNT}, (_, i) => ({
            id: i,
            left: Math.random() * 100,
            delay: Math.random() * 0.8,
            color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
            size: 5 + Math.random() * 10,
            shape: Math.random() > 0.5 ? '50%' : '2px',
        }));
    }

    render() {
        const {classes, goalName} = this.props;

        return <>
            <div className={classes.overlay}>
                {this.confettiPieces.map(piece => (
                    <div
                        key={piece.id}
                        className={classes.confettiPiece}
                        style={{
                            left: `${piece.left}%`,
                            animationDelay: `${piece.delay}s`,
                            backgroundColor: piece.color,
                            width: piece.size,
                            height: piece.size,
                            borderRadius: piece.shape,
                        }}
                    />
                ))}
            </div>
            <div className={classes.banner}>
                <Grow in={true} timeout={400}>
                    <Box sx={{
                        background: 'linear-gradient(135deg, #66bb6a 0%, #43A047 50%, #2E7D32 100%)',
                        borderRadius: 3,
                        px: 4,
                        py: 2.5,
                        boxShadow: '0 8px 32px rgba(76, 175, 80, 0.5)',
                    }}>
                        <EmojiEventsIcon sx={{ fontSize: 40, color: '#FFD700', mb: 0.5 }}/>
                        <Typography variant="h6" sx={{ color: '#fff', fontWeight: 800, letterSpacing: '0.05em' }}>
                            GOAL REACHED!
                        </Typography>
                        {goalName &&
                            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)', mt: 0.5 }}>
                                {goalName}
                            </Typography>
                        }
                    </Box>
                </Grow>
            </div>
        </>;
    }
}

export default withStyles(useStyles)(GoalCompletedCelebration);
